export{Tab,TabButton,Tabs}from"@vds-core/tabs";
